import { Pipe, PipeTransform , NgModule, Injectable} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeUrl'
})
@Injectable()
export class sanitizeUrlPipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) {}

    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

}
@Pipe({
   name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

@NgModule({
    imports: [],
    declarations: [ 
        sanitizeUrlPipe,
        SafeHtmlPipe
    ],
    exports: [
        sanitizeUrlPipe,
        SafeHtmlPipe
    ]
  })
  export class sanitizeUrlPipes {}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/sanitizerUrl.pipe.ts